import React, { useState, useEffect } from "react";
import { Eye, EyeOff, Edit } from "react-feather";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios"; // Import axios
import { baseurl } from "../../Baseurl";
import { useNavigate, Link } from "react-router-dom";
import Swal from 'sweetalert2';


const SellerProfile = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [sellerData, setSellerData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    seller_email: "",
    phone: "",
    country: "",
    region: "",
  });

const [countries, setCountries] = useState([]);

  useEffect(() => {
    axios.get(`${baseurl}getAllCountries`).then((res) => {
      setCountries(res.data.countries || []);
    });
  }, []);
  
  const [loading, setLoading] = useState(true);
  const sellerId = localStorage.getItem("seller_id"); // Get seller ID from localStorage

  useEffect(() => {
    const fetchSellerData = async () => {
      try {
        const response = await axios.get(`${baseurl}fetchSellerById/${sellerId}`);
        if (response.data.message === "Seller data fetched successfully.") {
          setSellerData(response.data.data); // Set the fetched data
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching seller data:", error);
        setLoading(false);
      }
    };

    if (sellerId) {
      fetchSellerData();
    }
  }, [sellerId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSellerData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Add sellerId to the request body
    const updatedData = {
      ...sellerData,
      seller_id: sellerId, // Include sellerId in the body
    };
  
    // Console log the data being sent
    console.log("Data being sent to the server:", updatedData);
  
    try {
      // Send the request to update the seller data
      const response = await axios.post(`${baseurl}/update_seller`, updatedData);
  
      if (response.data.message === "Seller data updated successfully.") {
        // Show success message using SweetAlert2
        Swal.fire({
          icon: 'success',
          title: 'Profile updated successfully',
          text: 'Your profile has been updated.',
        });
      } else {
        // Show failure message using SweetAlert2
        Swal.fire({
          icon: 'error',
          title: 'Failed to update profile',
          text: 'There was an issue updating your profile. Please try again.',
        });
      }
    } catch (error) {
      console.error("Error updating seller data:", error);
      // Show error message using SweetAlert2
      Swal.fire({
        icon: 'error',
        title: 'An error occurred',
        text: 'There was an issue with the server. Please try again later.',
      });
    }
  };
  

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1">My Account</h4>
                  <p className="payttl">
                    Please update your profile information.
                  </p>
                  <hr />
                  <form className="contact-form text-start" onSubmit={handleSubmit}>
                    <div className="row g-2">
                      <div className="col-md-4">
                        <label htmlFor="first_name" className="form-label">
                          First Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="first_name"
                          name="first_name"
                          className="form-control"
                          placeholder="Enter your first name"
                          value={sellerData.first_name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>


                      <div className="col-md-4">
                        <label htmlFor="middle_name" className="form-label">
                          Middle Name 
                        </label>
                        <input
                          type="text"
                          id="middle_name"
                          name="middle_name"
                          className="form-control"
                          placeholder="Enter your Middle Name"
                          value={sellerData.middle_name}
                          onChange={handleInputChange}
                          
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="last_name" className="form-label">
                          Last Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="last_name"
                          name="last_name"
                          className="form-control"
                          placeholder="Enter your last name"
                          value={sellerData.last_name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="col-md-12">
                        <label htmlFor="email" className="form-label">
                          Email<span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="seller_email"
                          className="form-control"
                          placeholder="Enter your email address"
                          value={sellerData.seller_email}
                          onChange={handleInputChange}
                          disabled
                        />
                        <div className="text-end">
                        <small><Link className="editemail"><Edit size={15}/>&nbsp;Update Email</Link></small>
                        </div>
                        
                      </div>


                      <div className="col-md-12">
                        <label htmlFor="phone" className="form-label">
                          Phone Number<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          id="phone"
                          name="phone"
                          className="form-control"
                          placeholder="Enter your phone number"
                          value={sellerData.phone || ""}
                          // onChange={handleInputChange}

                          onChange={(e) => {
                            const input = e.target.value;
                            // Allow only digits, and limit to 10 characters
                            if (/^\d{0,10}$/.test(input)) {
                              handleInputChange(e);
                            }
                          }}
                          maxLength={10}

                        />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="country" className="form-label">
                          Country<span className="text-danger">*</span>
                        </label>
                        {/* <input
                          type="text"
                          id="country"
                          name="country"
                          className="form-control"
                          placeholder="Enter your country"
                          value={sellerData.country || ""}
                          onChange={handleInputChange}
                        /> */}
                        <select
      id="country"
      name="country"
      className="form-control"
      value={sellerData.country || ""}
      onChange={handleInputChange}
    >
      <option value="">Select Country/Region</option>
      {countries.map((c) => (
        <option key={c.id} value={c.country_name}>
          {c.country_name}
        </option>
      ))}
    </select>

                      </div>

                      <div className="col-md-6">
                        <label htmlFor="region" className="form-label">
                          Region 
                        </label>
                        <input
                          type="text"
                          id="region"
                          name="region"
                          className="form-control"
                          placeholder="Enter your region"
                          value={sellerData.region || ""}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="mt-3 text-end">
                      <button type="submit" className="btn submitbtnn w-25">
                        Update
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SellerProfile;
